import React from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import Nav from "./Nav";
import { useSelector } from "react-redux";

const MobileMenu = ({ MobileHandler }) => {
  const {currentCustomer} = useSelector(state => state.store);
  return (
    <div className="mobilemenu-popup">
      <div className="mobilemenu-inner">
        <div className="mobilemenu-header">
          <div className="mobile-nav-logo">
            <Link to={process.env.PUBLIC_URL + "/"}>
              {/* limage={window["logo_white"]}
                  dimage={window["logo_black"]}
                  simage={window["logo_white"]} */}
              <img
                className="light-mode"
                src={window["logo_white"]}
                alt="Site Logo"
              />
              <img
                className="dark-mode"
                src={window["logo_black"]}
                alt="Site Logo"
              />
            </Link>
          </div>
          <button className="mobile-menu-close" onClick={MobileHandler}>
            <FaTimes />
          </button>
        </div>
        <div className="mobilemenu-body">
          <div className="header-action ">
            <ul className="list-unstyled">
              <li className="buy-btn">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  //   href={window["APP_HOME"]}
                  className="gc-btn btn-gradient-purple"
                  onClick={() => {
                    window.open(
                      `https://${window.location.host}${window["APP_HOME"]}`,
                      "_blank"
                    );
                  }}
                >
                  {currentCustomer?.apps_config?.systemName || "Gobierno Electrónico"}
                </a>
              </li>
            </ul>
          </div>
          <Nav />
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
